// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import constants from "@store/constants";
import SearchTextField, { SearchTextFieldStyles } from "@store/Library/Widgets/ShipmentHistory/SearchTextField";
import * as React from "react";

export const orderNumberStyles: SearchTextFieldStyles = {};
const styles = orderNumberStyles;

const ShipmentHistorySearchFieldOrderNumber: React.FunctionComponent<WidgetProps> = () => {
    return (
        <SearchTextField
            styles={styles}
            parameterField="greifOrderNumber"
            label={translate("Greif Order #")}
            inputType="text"
            placeholder=""
            testSelector="shipmentHistory_filterOrderNumber"
        />
    );
};

const widgetModule: WidgetModule = {
    component: ShipmentHistorySearchFieldOrderNumber,
    definition: {
        group: constants.widgetGroup.shipmentHistory,
        allowedContexts: [constants.pageType.shipmentHistory],
        displayName: "Order Number",
    },
};

export default widgetModule;
